import { render } from "./FCCategory.vue?vue&type=template&id=7af52bd4&scoped=true"
import script from "./FCCategory.vue?vue&type=script&lang=js"
export * from "./FCCategory.vue?vue&type=script&lang=js"

import "./FCCategory.vue?vue&type=style&index=0&id=7af52bd4&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af52bd4"]])

export default __exports__